export default __webpack_public_path__ + "static/media/ck-nav-logo-2022.950ce4e3.svg";